import { isDefinedString } from "et3-type-guards";
import i18n from "../../../../../../../constants/i18n";
import Et3Image from "../../../../../../../core/et3-Image";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const DescriptionStatusImage = withLiteObserverAndTheme<{
  imageStatusLogoSource: string;
  description: string;
}>((props) => {
  const { theme, imageStatusLogoSource, description } = props;
  const { colors } = theme;

  return isDefinedString(description) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="flex-end"
      withShadow={false}
      width={380}
      height={45}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER")}
        imageName={imageStatusLogoSource}
        size={39}
        onClick={() => {}}
        style={{}}
      />
    </ET3Div>
  ) : null;
});

export default DescriptionStatusImage;
